import React from 'react';
import TrackingService from '@/services/tracking';
import ConstructionCaseCard from '@/ui/ConstructionCaseCard';
import { HStack, VStack, Text, Icongraphy, Box } from '@design-system/pc';
import { ApiPagingResponseData } from '@remodeling/base';
import { ConstructionCaseContent } from '@remodeling/content';
import styled from 'styled-components';

interface ConstructionProps {
  type?: string;
  constructData?: ApiPagingResponseData<ConstructionCaseContent>;
  handleConstructionPopup: () => void;
  gtmValue?: Record<string, any>;
}

const Construction = ({
  type,
  constructData,
  handleConstructionPopup,
  gtmValue,
}: ConstructionProps) => {
  return (
    <Container
      {...TrackingService.tagGTM(`constructioncase_list_preview`, gtmValue)}
    >
      <HeaderContainer>
        <TitleContainer>
          <Title variant="subTitle4" color="color_chip.primary">
            {type && `${type} `}시공사례
          </Title>
          <DataAmount variant="subTitle4">
            ({constructData?.totalElements})
          </DataAmount>
        </TitleContainer>
        {constructData && constructData?.totalElements > 4 && (
          <MoreContainer
            onClick={handleConstructionPopup}
            {...TrackingService.tagGTM(
              `constructioncase_list_preview_more_button`,
              gtmValue,
            )}
          >
            <Box>
              <Text variant="label_lg_r" color="color_chip.gray.700">
                더보기
              </Text>
            </Box>
            <Icongraphy
              variant="ic_arrow_right"
              fillColor="color_chip.gray.700"
              useFillColor={true}
              size={16}
              resize
            />
          </MoreContainer>
        )}
      </HeaderContainer>
      <CardWrap>
        {constructData?.content.map(
          (item, index) =>
            index < 4 && (
              <CardBox key={item.id} width={'375px'}>
                <ConstructionCaseCard
                  item={item}
                  imgSize={{ width: '375px', height: '211px' }}
                />
              </CardBox>
            ),
        )}
      </CardWrap>
    </Container>
  );
};

export default Construction;

const Container = styled(VStack)`
  margin-bottom: 80px;
  gap: 24px;
`;

const HeaderContainer = styled(HStack)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const TitleContainer = styled(HStack)`
  gap: 4px;
  align-items: center;
`;

const Title = styled(Text)``;
const DataAmount = styled(Text)``;

const MoreContainer = styled(HStack)`
  gap: 2px;
  align-items: center;
  cursor: pointer;
`;

const CardWrap = styled(Box)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 28px 20px;
`;

const CardBox = styled(Box)<{ width: string }>`
  width: ${({ width }) => width};
`;
